import { render, staticRenderFns } from "./bankDeposit.vue?vue&type=template&id=2cb869aa&scoped=true"
import script from "./bankDeposit.vue?vue&type=script&lang=js"
export * from "./bankDeposit.vue?vue&type=script&lang=js"
import style0 from "./bankDeposit.vue?vue&type=style&index=0&id=2cb869aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb869aa",
  null
  
)

export default component.exports